export const FEATURE_FLAGS = {
  LINE_CHART_REPORT: 'lineChartReports',
  DISPLAY_UPCOMING_MAINTENANCE: 'displayUpcomingMaintenance',
  DISABLE_NOTIFICATION_POLLING: 'disableNotificationPolling',
  ENABLE_AUTO_CASE_LINKING: 'exp-4326_auto_case_linking',
  ENABLE_FLEET_MANAGEMENT_MOCKS: 'exp-4646_fleet_management_mocks',
  PD_1188_ROUTE_BASED_FLEET_MANAGEMENT:
    'exp-PD-1188_route_based_fleet_management',
  PD_1636_DEFAULT_SERVICE_NETWORKS: 'exp-PD-1636_default_service_networks',
} as const;
